import { getPlans, Plan } from "@/services/checkout.service"
import { getPlanPermissions, updatePermissionsForPlan, IPlanPermission } from "@/services/plan-permission/plan-permission.service"
import { useRequest } from "ahooks"
import { Button, Card, Checkbox, List, Modal, Spin, message } from "antd"
import Title from "antd/es/typography/Title"
import { useState } from "react"

export function PlanSetting() {
  const { data: plans = [], loading: loadingPlans, run: runGetPlans } = useRequest(getPlans)
  const { data: allPermissions = [], loading: loadingPermissions } = useRequest(getPlanPermissions)

  const loading = loadingPlans || loadingPermissions

  return (
    <div className="p-4">
      <Spin spinning={loading}>
        <List
          grid={{ gutter: 16, column: 2 }}
          dataSource={plans}
          renderItem={(plan) => (
            <List.Item>
              <PlanCard plan={plan} allPermissions={allPermissions} reload={runGetPlans} />
            </List.Item>
          )}
        />
      </Spin>
    </div>
  )
}

function PlanCard({ plan, allPermissions, reload }: { plan: Plan; allPermissions: IPlanPermission[]; reload: () => void }) {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [selectedPermissions, setSelectedPermissions] = useState<string[]>([])
  const [saving, setSaving] = useState(false)

  const openModal = async () => {
    setIsModalOpen(true)
    const perms = plan.permissions?.map(item => item.code) || []
    setSelectedPermissions(perms || [])
  }

  const handleOk = async () => {
    setSaving(true)
    try {
      const permissions = selectedPermissions.map(code => {
        return allPermissions.find(perm => perm.code === code)!
      })
      await updatePermissionsForPlan(plan.id, permissions)
      message.success('Permissions updated successfully')
      setIsModalOpen(false)
    } catch (e) {
      message.error('Failed to update permissions')
    } finally {
      setSaving(false)
    }
    await reload()
  }

  return (
    <>
      <Card title={plan.name} style={{minWidth: 200}} extra={<Button type="link" onClick={openModal}>Permissions</Button>}>
        <p>{plan.description}</p>
        <Title level={5} className="mt-1">Permssions</Title>
        <div>
           {plan.permissions?.map((item, index) => (
             <div key={index}>- {item.description}</div>
           ))}
        </div>
      </Card>

      <Modal
        title={`Manage Permissions for ${plan.name}`}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={() => setIsModalOpen(false)}
        confirmLoading={saving}
      >
        {
          <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
             <Checkbox.Group
                style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}
                value={selectedPermissions}
                onChange={(checkedValues) => setSelectedPermissions(checkedValues as string[])}
             >
                {allPermissions.map(perm => (
                  <Checkbox key={perm.code} value={perm.code}>
                    {perm.code} - <span style={{ color: '#888' }}>{perm.description}</span>
                  </Checkbox>
                ))}
             </Checkbox.Group>
          </div>
        }
      </Modal>
    </>
  )
}
